import { createRouter, createWebHistory } from 'vue-router'
import { absorbOAuthTokenFromUrl } from '@/shared/utils/wxMpOAuth'
import Home from '@/views/Home.vue'
import { applyPageSeo, applySiteJsonLd, DEFAULT_SITE_DESCRIPTION } from '@/shared/utils/seo'
import ComicDetail from '../views/ComicDetail.vue'
import ComicSearch from '@/views/ComicSearch.vue'
import UserCenter from '@/views/UserCenter.vue'
import ComicReader from '@/views/ComicReader.vue'
import RequestComic from '@/views/RequestComic.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '橘子漫嘎 - 首页',
      seoDescription:
        '橘子漫嘎首页：浏览热门与分类漫画，搜索你想读的作品，开启在线下拉式阅读体验。'
    }
  },
  {
    path: '/comic/:id', // 动态路由参数，id 表示漫画的唯一标识
    name: 'ComicDetail',
    component: ComicDetail,
    props: true, // 将路由参数作为属性传递给 ComicDetail
    meta: {
      title: '橘子漫嘎 - 漫画详情',
      seoDescription: '查看漫画简介、卷目录与读者评论，在橘子漫嘎开始或继续阅读。'
    }
  },
  {
    path: '/comicsearch',
    name: 'ComicSearch',
    component: ComicSearch,
    meta: {
      title: '橘子漫嘎 - 分类',
      seoDescription: '按题材与分类发现漫画，快速找到符合条件的作品。'
    }
  },
  {
    path: '/user-center/:section?',
    name: 'UserCenter',
    component: UserCenter,
    props: true,
    meta: {
      title: '橘子漫嘎 - 个人中心',
      seoDescription: '管理账号信息、收藏、观看历史与会员权益。'
    }
  },
  {
    path: '/user-center/module/:module',
    name: 'UserModule',
    component: () => import('@/views/UserModulePage.vue'),
    props: true,
    meta: {
      title: '橘子漫嘎 - 个人中心',
      seoDescription: '个人中心功能模块：账户与阅读管理。'
    }
  },
  {
    path: '/comic/reader/:comicId/:volNum', // 将 volNum 作为路径参数
    name: 'ComicReader',
    component: ComicReader,
    props: true, // 启用路由参数传递
    meta: {
      title: '橘子漫嘎 - 在线阅读',
      seoDescription: '下拉式阅读漫画正文，支持目录切换与卷内互动。'
    }
  },
  {
    path: '/request-comic',
    name: 'RequestComic',
    component: RequestComic,
    meta: {
      title: '橘子漫嘎 - 求漫',
      seoDescription: '提交你想看的漫画，与平台一起丰富书库。'
    }
  },
  {
    path: '/comic/tip',
    name: 'ComicTipPay',
    component: () => import('@/views/ComicTipPay.vue'),
    meta: {
      title: '橘子漫嘎 - 打赏支付',
      seoDescription: '漫画打赏微信支付页。',
      robots: 'noindex, nofollow'
    }
  }
]

const router = createRouter({
  // History 模式：地址为 /comic/123，无 #。生产环境需 Web 服务器把所有「无前缀文件」的请求回退到 index.html
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由切换时同步标题与基础 meta（详情/阅读页会在加载数据后再次覆盖）
router.beforeEach((to, from, next) => {
  absorbOAuthTokenFromUrl()
  const title = to.meta.title || '橘子漫嘎'
  const desc = to.meta.seoDescription || DEFAULT_SITE_DESCRIPTION
  applyPageSeo({ title, description: desc })
  applySiteJsonLd()
  next()
})

export default router
